import React, { useState } from 'react';
import styles from './AddClients.module.css';
import { addClientBd } from '../../firebase';
import LoaderPage from '../LoaderPage/LoaderPage';
import { useDispatch } from 'react-redux';
import { unshiftClientRedux } from '../../store/slices/clientsSlice';
import { generateRandomString } from '../../helper';

export default function AddClients({ setPopup }) {
  const dispatch = useDispatch();
  const [name, setName] = useState('');
  const [surname, setSurname] = useState('');
  const [tel, setTel] = useState('');
  const [fromAdvertising, setFromAdvertising] = useState(false);
  const [ownСlient, setOwnСlient] = useState(false);
  const [potentialClient, setPotentialClient] = useState(false);
  const [loader, setLoader] = useState(false);

  const addClient = async (clientData) => {
    setLoader(true);
    const data = {
      name: clientData.name.trim(),
      surname: clientData.surname.trim(),
      fullName: clientData.name.trim() + ' ' + clientData.surname.trim(),
      tel: clientData.tel.trim(),
      client_id: generateRandomString(15),
      time_milliseconds: new Date().getTime(), // Мілісікунди з  1 січня 1970 року
      date: new Date().toLocaleDateString(), // Дата додавання
      date_time: new Date().toLocaleTimeString(), // Час додавання
      date_day: new Date().getDay(), // День додавання
      notes: '',
      fromAdvertising: fromAdvertising, // Чи цей клієнт прийшов з реклами
      ownСlient: ownСlient, // Клієнт який знайшла самостійно
      potentialClient: potentialClient, // Потенційний клієнт
      participationGroups: {},
      accessMeasurements: {},
    };

    const isAddClientBd = await addClientBd(data);
    if (isAddClientBd) {
      dispatch(unshiftClientRedux({ ...data, newClient: true }));
      alert('Клієнта і користувача додано успішно.');
    }
    setPopup(false);
    setLoader(false);
  };

  return (
    <>
      <div className={styles.popup_wrapper}>
        <div className={styles.popup_contnent_wrapper}>
          <button className={styles.popup_close_btn} onClick={() => setPopup(false)}>
            Закрити
          </button>
          Ім’я
          <input
            className={styles.popup_input}
            type="text"
            value={name}
            onChange={(e) => setName(e.target.value)}
          />
          Прізвище
          <input
            className={styles.popup_input}
            type="text"
            value={surname}
            onChange={(e) => setSurname(e.target.value)}
          />
          Телефон
          <input
            className={styles.popup_input}
            type="tel"
            value={tel}
            placeholder="380966054541"
            onChange={(e) => setTel(e.target.value)}
          />
          <div className={styles.fromAdvertising_wrapper + ' mb_15'}>
            Клієнт з реклами
            <div
              className={
                fromAdvertising
                  ? styles.fromAdvertising_btn_active + ' ' + styles.fromAdvertising_btn
                  : styles.fromAdvertising_btn
              }
              onClick={() => (
                setFromAdvertising(!fromAdvertising), setOwnСlient(false), setPotentialClient(false)
              )}></div>
          </div>
          <div className={styles.fromAdvertising_wrapper + ' mb_15'}>
            Клієнт був на супроводі
            <div
              className={
                ownСlient
                  ? styles.ownСlient_btn_active + ' ' + styles.fromAdvertising_btn
                  : styles.fromAdvertising_btn
              }
              onClick={() => (
                setOwnСlient(!ownСlient), setFromAdvertising(false), setPotentialClient(false)
              )}></div>
          </div>
          <div className={styles.fromAdvertising_wrapper}>
            Потенційний клієнт
            <div
              className={
                potentialClient
                  ? styles.potentialClient_btn_active + ' ' + styles.fromAdvertising_btn
                  : styles.fromAdvertising_btn
              }
              onClick={() => (
                setPotentialClient(!potentialClient), setOwnСlient(false), setFromAdvertising(false)
              )}></div>
          </div>
          <div className={styles.popup_add_btn_wrapper}>
            <button
              className={styles.popup_add_btn}
              onClick={() => addClient({ name, surname, tel })}>
              Додати
            </button>
          </div>
        </div>
      </div>
      {loader && <LoaderPage />}
    </>
  );
}
